module.exports = __webpack_public_path__ + "img/p1-pic.0e6efb60.jpg";